export interface Validation {
  isValid: boolean;
  validationMessage: string;
}

const SALESFORCE_PHONE_LENGTH = 40;
const SALESFORCE_EMAIL_LENGTH = 80;
const SALESFORCE_NAME_LENGTH = 80;
const SALESFORCE_COMPANY_LENGTH = 109;
const SALESFORCE_MESSAGE_LENGTH = 32000;

const MESSAGE_VALIDATION_EMPTY = 'Please, describe your project';
const MESSAGE_VALIDATION_LONG = `Message is too long (maximum is ${SALESFORCE_MESSAGE_LENGTH} characters)`;
const NAME_VALIDATION = 'Please, enter your name';
const NAME_VALIDATION_LONG = `Name is too long (maximum is ${SALESFORCE_NAME_LENGTH} characters)`;
const EMAIL_VALIDATION = 'Please, enter a valid email';
const EMAIL_VALIDATION_LONG = `Email is too long (maximum is ${SALESFORCE_EMAIL_LENGTH} characters)`;
const PHONE_VALIDATION = 'Please, enter a valid phone number';
const PHONE_VALIDATION_LONG = `Phone is too long (maximum is ${SALESFORCE_PHONE_LENGTH} characters)`;
const COMPANY_VALIDATION_LONG = `Company name is too long (maximum is ${SALESFORCE_COMPANY_LENGTH} characters)`;

// eslint-disable-next-line prefer-regex-literals
const spaceCheck = new RegExp('\\S');
const emailTester =
  // eslint-disable-next-line no-control-regex, no-useless-escape
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
const phoneTester = /^\+?([0-9()][- ]?)+$/;

export const validateName = (value: string): Validation => {
  const isValid =
    !!value && value.length > 1 && value.length <= SALESFORCE_NAME_LENGTH && spaceCheck.test(String(value));
  const validationMessage = value.length > SALESFORCE_NAME_LENGTH ? NAME_VALIDATION_LONG : NAME_VALIDATION;

  return { isValid, validationMessage };
};

export const validatePhone = (phone: string): Validation => {
  const isValid = phone.length > 3 && phone.length <= SALESFORCE_PHONE_LENGTH && phoneTester.test(String(phone));
  const validationMessage = phone.length > SALESFORCE_PHONE_LENGTH ? PHONE_VALIDATION_LONG : PHONE_VALIDATION;

  return { isValid, validationMessage };
};

export const validateCompany = (company: string): Validation => {
  const isValid = company.length <= SALESFORCE_COMPANY_LENGTH;
  const validationMessage = COMPANY_VALIDATION_LONG;

  return { isValid, validationMessage };
};

export const validateEmail = (email: string): Validation => {
  const isValid = !!email && email.length <= SALESFORCE_EMAIL_LENGTH && emailTester.test(String(email));
  const validationMessage = email.length > SALESFORCE_EMAIL_LENGTH ? EMAIL_VALIDATION_LONG : EMAIL_VALIDATION;

  return { isValid, validationMessage };
};

export const validateMessage = (message: string): Validation => {
  const isValid = !!message && message.length <= SALESFORCE_MESSAGE_LENGTH && spaceCheck.test(String(message));
  const validationMessage =
    message && spaceCheck.test(String(message)) ? MESSAGE_VALIDATION_LONG : MESSAGE_VALIDATION_EMPTY;

  return { isValid, validationMessage };
};
